import { render, staticRenderFns } from "./ServiceRail.vue?vue&type=template&id=2a548694&"
import script from "./ServiceRail.vue?vue&type=script&lang=js&"
export * from "./ServiceRail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports